import Angry from '../svg/Emotions/Angry'
import Calm from '../svg/Emotions/Calm'
import Ecstatic from '../svg/Emotions/Ecstatic'
import Empty from '../svg/Emotions/Empty'
import Grumpy from '../svg/Emotions/Grumpy'
import Happy from '../svg/Emotions/Happy'
import Inspired from '../svg/Emotions/Inspired'
import Lethargic from '../svg/Emotions/Lethargic'
import Sad from '../svg/Emotions/Sad'
import Stressed from '../svg/Emotions/Stressed'
import { ReactComponent as MyselfIcon } from '../svg/HowAreYouSvgs/MyselfIcon.svg'
import { ReactComponent as FamilyIcon } from '../svg/HowAreYouSvgs/FamilyIcon.svg'
import { ReactComponent as FriendsIcon } from '../svg/HowAreYouSvgs/FriendsIcon.svg'
import { ReactComponent as SchoolIcon } from '../svg/HowAreYouSvgs/SchoolIcon.svg'
import { ReactComponent as SocialMediaIcon } from '../svg/HowAreYouSvgs/SocialMediaIcon.svg'
import { ReactComponent as WellbeingIcon } from '../svg/HowAreYouSvgs/WellbeingIcon.svg'
import { ReactComponent as HealthIcon } from '../svg/HowAreYouSvgs/HealthIcon.svg'
import { ReactComponent as AchievementIcon } from '../svg/HowAreYouSvgs/AchievementIcon.svg'
import { ReactComponent as SleepIcon } from '../svg/HowAreYouSvgs/SleepIcon.svg'
import instructionVideo from '../assets/images/InstructionVideo.png'
import instructionVideo2 from '../assets/images/InstructionVideo2.png'

import EnterApplication from '../assets/images/achievements/EnterApplication.png'
import MonthlyStreak from '../assets/images/achievements/MonthlyStreak.png'
import ReadAndLike from '../assets/images/achievements/ReadAndLike.png'
import AnswerHowAreYou from '../assets/images/achievements/AnswerHowAreYou.png'
import DedicatedUser from '../assets/images/achievements/DedicatedUser.png'
import Complete10Tasks from '../assets/images/achievements/Complete10Tasks.png'
import ExploreAllFeatures from '../assets/images/achievements/ExploreAllFeatures.png'
import ProvideDailyFeedback from '../assets/images/achievements/ProvideDailyFeedback.png'
import SetUpAchievementsGoal from '../assets/images/achievements/SetUpAchievementsGoal.png'

import deLocale from 'date-fns/locale/de'
import enLocale from 'date-fns/locale/en-US'
import arLocale from 'date-fns/locale/ar-SA'
import Good from '../svg/Emotions/Good'
import Numb from '../svg/Emotions/Numb'
import Worried from '../svg/Emotions/Worried'

export const localeMap = {
    ar: arLocale,
    en: enLocale,
    de: deLocale,
}

export const TOAST_DURATION = 4000

export const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
export const emotions_list = ['happy', 'ecstatic', 'inspired', 'calm', 'good', 'numb', 'worried', 'lethargic', 'grumpy', 'sad', 'stressed', 'angry']
export const sad_emotions = ['lethargic', 'grumpy', 'sad', 'stressed', 'angry']
// todo color dark not seted for:  good:"#BAEF90",  numb:"#399AF4",  worried:'#E4A6B1',

export const emotions_color_dark = {
    happy: '#9D4F20',
    ecstatic: '#891A1C',
    inspired: '#95225B',
    calm: '#3A79B9',
    good: '#BAEF90',
    numb: '#399AF4',
    worried: '#E4A6B1',
    lethargic: '#65318C',
    grumpy: '#186C2D',
    sad: '#1F4B99',
    stressed: '#862D98',
    angry: '#82133A',
    afraid: '#82133A',
    excited: '#82133A',
}

export const emotions_color = {
    happy: '#FDDF6D',
    ecstatic: '#F47C39',
    inspired: '#ED68A0',
    calm: '#83CDF5',
    good: '#BAEF90',
    numb: '#399AF4',
    worried: '#E4A6B1',
    lethargic: '#C1A7ED',
    grumpy: '#6FCC87',
    sad: '#689CFA',
    stressed: '#DC8CDD',
    angry: '#FC4C59',

    false: ' rgba(31, 31, 67, 0.05)',
    afraid: 'rgba(31, 31, 67, 0.05)',
    excited: 'rgba(31, 31, 67, 0.05)',
}

export const emotions_heads = {
    happy: <Happy />,
    ecstatic: <Ecstatic />,
    inspired: <Inspired />,
    calm: <Calm />,
    good: <Good />,
    numb: <Numb />,
    worried: <Worried />,
    lethargic: <Lethargic />,
    grumpy: <Grumpy />,
    sad: <Sad />,
    stressed: <Stressed />,
    angry: <Angry />,

    default: <Empty />,
    motivated: <Empty />,
    false: <Empty />,
    afraid: <Empty />,
    excited: <Empty />,
}
export const mainReasonListIconsBlue = [
    <MyselfIcon fill="#153c4f" />,
    <FamilyIcon fill="#153c4f" />,
    <FriendsIcon fill="#153c4f" />,
    <SchoolIcon fill="#153c4f" />,
    <SocialMediaIcon fill="#153c4f" />,
    <WellbeingIcon fill="#153c4f" />,
    <HealthIcon fill="#153c4f" />,
    <AchievementIcon fill="#153c4f" />,
    <SleepIcon fill="#153c4f" />,
]
export const mainReasonListIconsWhite = [
    <MyselfIcon fill="#ECEBF8" />,
    <FamilyIcon fill="#ECEBF8" />,
    <FriendsIcon fill="#ECEBF8" />,
    <SchoolIcon fill="#ECEBF8" />,
    <SocialMediaIcon fill="#ECEBF8" />,
    <WellbeingIcon fill="#ECEBF8" />,
    <HealthIcon fill="#ECEBF8" />,
    <AchievementIcon fill="#ECEBF8" />,
    <SleepIcon fill="#ECEBF8" />,
]
export const mainReasonList = ['Myself', 'Family', 'Friends', 'School', 'Social media', 'Wellbeing', 'Health', 'Achievement', 'Sleep']
// export const achievementsList = [
// 	<EnterApplication />,
// 	<MonthlyStreak />,
// 	<ReadAndLike />,
// 	<AnswerHowAreYou />,
// 	<DedicatedUser />,
// 	<Complete10Tasks />,
// 	<ExploreAllFeatures />,
// 	<ProvideDailyFeedback />,
// 	<SetUpAchievementsGoal />,
// ];
export const achievementsListObject = {
    a1: (
        <div style={{ width: 114, height: 94 }}>
            <img src={EnterApplication} />
        </div>
    ),
    a2: (
        <div style={{ width: 114, height: 94 }}>
            <img src={MonthlyStreak} />
        </div>
    ),
    a3: (
        <div style={{ width: 114, height: 94 }}>
            <img src={ReadAndLike} />
        </div>
    ),
    a4: (
        <div style={{ width: 114, height: 94 }}>
            <img src={AnswerHowAreYou} />
        </div>
    ),
    a5: (
        <div style={{ width: 114, height: 94 }}>
            <img src={DedicatedUser} />
        </div>
    ),
    a6: (
        <div style={{ width: 114, height: 94 }}>
            <img src={Complete10Tasks} />
        </div>
    ),
    a7: (
        <div style={{ width: 114, height: 94 }}>
            <img src={ExploreAllFeatures} />
        </div>
    ),
    a8: (
        <div style={{ width: 114, height: 94 }}>
            <img src={ProvideDailyFeedback} />
        </div>
    ),
    a9: (
        <div style={{ width: 114, height: 94 }}>
            <img src={SetUpAchievementsGoal} />
        </div>
    ),
}

export const videoList = ['https://videos.upstrivesystem.com/StudentFullDesktopInstructionVideo.mp4', 'https://videos.upstrivesystem.com/StudentMobileInstructionVideo1080.mp4']

export const instructionVideos = [
    {
        title: 'Student Desktop Tutorial',
        description: 'Learn how to get the best out of the desktop version of Upstrive by exploring all the features and functionalities this version has to offer.',
        url: 'https://videos.upstrivesystem.com/StudentFullDesktopInstructionVideo.mp4',
        img: instructionVideo,
    },
    {
        title: 'Student Mobile App Tutorial',
        description: 'Discover all the features, tips and tools to get the best out of your mobile application.',
        url: 'https://videos.upstrivesystem.com/StudentMobileInstructionVideo1080.mp4',
        img: instructionVideo2,
    },
]
